import { filter, map, withLatestFrom } from 'rxjs/operators';
import { fromEventPattern, fromEvent } from 'rxjs';
import { api as masterApi } from '@/api/api';
import { inWindow, isElectron } from '@/config';
export const THUMBNAIL_SIZE = 3 * 1024 * 1024;
export class IM_Cache {
    constructor() {
        this.sdk = null;
        this.systemApi = masterApi.getSystemApi();
        this.httpApi = masterApi.getDataTransApi();
        this.serverEmojiList = undefined;
    }
    init(sdk) {
        this.sdk = sdk;
        if (!inWindow() || window.isBridgeWorker || window.isAccountBg) {
            return;
        }
        setTimeout(() => {
            this.fetchServerEmojiList();
        }, 1500);
    }
    onmsg() {
        const onmsg = (handler) => {
            this.sdk.subscrible('onmsg', handler);
        };
        const offmsg = (handler) => {
            this.sdk.unSubcrible('onmsg', handler);
        };
        const $curSession = this.sdk.currentSession.getSubject();
        const $teamMuteStream = this.sdk.teamMuteStream.getSubject();
        const $event = fromEventPattern(onmsg, offmsg);
        const $visibleChange = fromEvent(document, 'visibilitychange').pipe(map(() => document.visibilityState));
        $event
            .pipe(filter(msg => msg.type === 'image'), filter(msg => !msg.isMuted), withLatestFrom($curSession, $visibleChange), filter(([msg, sessionId, visibilityState]) => {
            if (visibilityState === 'hidden') {
                return isElectron();
            }
            return msg.sessionId !== sessionId && isElectron();
        }), map(([msg]) => msg), withLatestFrom($teamMuteStream), filter(([msg, teamMuteList]) => {
            if (msg.scene === 'team') {
                return !teamMuteList.includes(msg.to);
            }
            return !msg.isMuted;
        }), map(([msg]) => msg))
            .subscribe(msg => {
            const { size, w, h } = msg.file;
            let { url } = msg.file;
            if (size > THUMBNAIL_SIZE) {
                url = this.getThumbnailImg(url, {
                    width: Math.min(300, Math.max(w, h)),
                    height: Math.min(300, Math.max(w, h)),
                });
            }
            else {
                url = this.getThumbnailImg(url);
            }
            if (window.bridgeApi && window.bridgeApi.master) {
                window.bridgeApi.master.requestData({
                    namespace: 'common',
                    apiname: 'cacheImage',
                    args: [url],
                });
            }
        });
    }
    getThumbnailImg(url, thumbnailConfig) {
        const params = {
            url,
            strip: true,
            interlace: true,
            thumbnail: Object.assign(Object.assign({}, thumbnailConfig), { mode: 'contain' }),
        };
        const newImgUrl = this.sdk.getInstance().viewImageSync(params);
        return newImgUrl;
    }
    async fetchServerEmojiList() {
        if (Array.isArray(this.serverEmojiList)) {
            return this.serverEmojiList;
        }
        const url = this.systemApi.getUrl('getCustomEmoji');
        const res = (await this.httpApi.get(url));
        this.serverEmojiList = res.data.data;
        return this.serverEmojiList;
    }
    getServerEmojis() {
        return (this.serverEmojiList || []).filter(item => item.valid);
    }
}
